var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2754",
    "data-name": "\\uADF8\\uB8F9 2754",
    transform: "translate(-928 -336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-users",
    "data-name": "Icon feather-users",
    transform: "translate(934.957 344.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_419",
    "data-name": "\\uD328\\uC2A4 419",
    d: "M16.559,30.1a1,1,0,0,1-1-1V26.9c0-1.874-1.24-3.4-2.765-3.4H5.265a2.507,2.507,0,0,0-1.9.939A3.769,3.769,0,0,0,2.5,26.9v2.2a1,1,0,1,1-2,0V26.9a5.768,5.768,0,0,1,1.343-3.761A4.475,4.475,0,0,1,5.265,21.5h7.529c2.627,0,4.765,2.422,4.765,5.4v2.2A1,1,0,0,1,16.559,30.1Z",
    transform: "translate(-1.5 -12.157)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_420",
    "data-name": "\\uD328\\uC2A4 420",
    d: "M11.265,3.5A4.765,4.765,0,1,1,6.5,8.265,4.77,4.77,0,0,1,11.265,3.5Zm0,7.53A2.765,2.765,0,1,0,8.5,8.265,2.768,2.768,0,0,0,11.265,11.03Z",
    transform: "translate(-3.735 -4.5)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_54",
    "data-name": "\\uD0C0\\uC6D0 54",
    d: "M14.5,3A11.5,11.5,0,0,0,6.368,22.632,11.5,11.5,0,0,0,22.632,6.368,11.425,11.425,0,0,0,14.5,3m0-3A14.5,14.5,0,1,1,0,14.5,14.5,14.5,0,0,1,14.5,0Z",
    transform: "translate(928 336)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.83ee433a2f7997c458d113b68f9dc391.svg";
export { ForwardRef as ReactComponent };